module.exports = __webpack_public_path__ + "img/food-kart.9566e1b1.png";